// 意大利语

export default {
  t1: 'Completa',
  t5: 'Paga',
  t6: 'Collega e autorizza',
}
